import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import config from '../config';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'fa',
        supportedLngs: ['fa', 'en', 'ar'],

        backend: {
            loadPath: config.app.baseUrl + 'locales/{{lng}}/{{ns}}.json',
        },

        ns: ['common', 'products', 'orders', 'auth'],
        defaultNS: 'common',

        interpolation: {
            escapeValue: false,
        },

        react: {
            useSuspense: true,
        },
    });

export default i18n;
